import accountOrder from '#common/store/accountOrder'
import checkout from '#common/store/checkout'
import siteNavigation from '#common/store/siteNavigation'
import subscriptionGifting from '#common/store/subscriptionGifting'
import workGroupTracker from '#common/store/workGroupTracker'
import Vuex from 'vuex'
import cart from './modules/cart'
import filters from './modules/filters'
import footer from './modules/footer'
import header from './modules/header'
import headerSearch from './modules/headerSearch'
import metadata from './modules/metadata'
import notifications from './modules/notifications'
import product from './modules/product'
import regionsFilters from './modules/regionsFilters'
import savedSearch from './modules/savedSearch'
import serverInit from './modules/serverInit'
import wineClub from './modules/wineClub'

const store = () =>
  new Vuex.Store({
    modules: {
      workGroupTracker,
      header,
      footer,
      serverInit,
      metadata,
      wineClub,
      accountOrder,
      checkout,
      subscriptionGifting,
      product,
      filters,
      regionsFilters,
      savedSearch,
      cart,
      notifications,
      siteNavigation,
      search,
      headerSearch,
    },
  })

export default store
